/*jshint esversion: 11 */

function toIdString(id) {
  if (!id) return '';
  if (typeof id === 'object' && id.$oid) return id.$oid;
  if (typeof id === 'object' && id._id) return toIdString(id._id);
  if (typeof id === 'object' && typeof id.toString === 'function') {
    return id.toString();
  }
  return String(id);
}

export function escapeCsvCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function getOrderedParents(child) {
  const parentMap = {};
  (child.parentDetail || []).forEach((p) => {
    const key = toIdString(p?._id);
    if (key) parentMap[key] = p;
  });

  const ordered = [];
  const seen = new Set();

  (child.parents || []).forEach((entry) => {
    const parentId = toIdString(entry?.parent?._id || entry?.parent);
    if (!parentId || seen.has(parentId)) return;
    const detail = parentMap[parentId];
    if (detail) {
      ordered.push(detail);
      seen.add(parentId);
    }
  });

  if (ordered.length === 0 && child.parentDetail?.length) {
    return child.parentDetail.filter((p) => p?._id);
  }

  return ordered;
}

export function buildChildrenCsv(children) {
  const rows = children || [];
  let maxParents = 0;
  let maxBatches = 0;

  rows.forEach((child) => {
    maxParents = Math.max(maxParents, getOrderedParents(child).length);
    maxBatches = Math.max(maxBatches, (child.batches || []).length);
  });

  // Always include at least two parent name/mobile column pairs
  const parentColumnCount = Math.max(maxParents, 2);

  const headers = ['Child Name', 'Email', 'Phone Number'];
  for (let i = 1; i <= parentColumnCount; i++) {
    headers.push(`Parent ${i} Name`, `Parent ${i} Mobile`);
  }
  for (let i = 1; i <= maxBatches; i++) {
    headers.push(`Batch ${i}`);
  }

  const csvRows = [headers.map(escapeCsvCell).join(',')];

  rows.forEach((child) => {
    const parents = getOrderedParents(child);
    const batches = child.batches || [];
    const cells = [
      child.name || '',
      child.email_address || '',
      child.phone_number && child.phone_number !== 'null' ? child.phone_number : ''
    ];

    for (let i = 0; i < parentColumnCount; i++) {
      const parent = parents[i];
      cells.push(parent?.name || '', parent?.phone_number || '');
    }

    for (let i = 0; i < maxBatches; i++) {
      cells.push(batches[i]?.name || '');
    }

    csvRows.push(cells.map(escapeCsvCell).join(','));
  });

  return csvRows.join('\n');
}

export function downloadCsv(csvContent, filename) {
  const blob = new Blob([`\uFEFF${csvContent}`], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
